import { config } from 'app-config';

import type { IAuthenticatedUser } from 'types/authentication';

export const sharingSiteUrl = (user: IAuthenticatedUser, referral = false, jobId?: number) => {
  let base = `${config.CAREERS_URL}/${user.company.name.toLowerCase()}/`;

  if (user.company.allJobsSharingUrl && !jobId) {
    base = `${user.company.allJobsSharingUrl}`;
  }

  if (jobId) {
    if (user.company.singleJobSharingUrl) {
      base = `${user.company.singleJobSharingUrl}`;
    }
    base += `${jobId}/`;
  }

  if (referral) {
    base += `?referral_uuid=${user.uuid}`;
  }

  return base;
};

export const notificationSettingsUrl = () => `/profile/notifications`;
export const applicationBaseUrl = (id: number, jobId: number) => `/jobs/${jobId}/application/${id}`;
export const applicationDetailUrl = (id: number, jobId: number) =>
  `/jobs/${jobId}/application/${id}/details`;
export const applicationRatingsUrl = (id: number, jobId: number) =>
  `/jobs/${jobId}/application/${id}/ratings`;
export const applicationMessagesUrl = (id: number, jobId: number) =>
  `/jobs/${jobId}/application/${id}/messages`;
export const applicationNotesUrl = (id: number, jobId: number) =>
  `/jobs/${jobId}/application/${id}/notes`;
export const applicationCopyUrl = (id: number, jobId: number) =>
  `/jobs/${jobId}/application/${id}/copy`;
export const applicationMoveUrl = (id: number, jobId: number) =>
  `/jobs/${jobId}/application/${id}/move`;
export const applicationOnboardingUrl = (id: number, jobId: number) =>
  `/jobs/${jobId}/onboarding/${id}`;
export const applicationOnboardingAppUrl = (id: number, jobId: number, triggerId: number) =>
  `/jobs/${jobId}/onboarding/${id}/integrations/${triggerId}`;
export const applicationOnboardingVerifyAppUrl = (id: number, jobId: number) =>
  `/jobs/${jobId}/onboarding/${id}/integrations`;

export const jobPipelineUrl = (id: number) => `/jobs/${id}/`;
export const jobNotesUrl = (id: number) => `/jobs/${id}/info/notes`;
